import {createReducer} from '@reduxjs/toolkit';
import {getArea} from 'ol/extent';
import GeoJSON from 'ol/format/GeoJSON';

import {fetchBasemapRules} from '@explorer/actions/basemap-rules.js';

const format = new GeoJSON();

const parseAoiGeo = aoi => ({
  type: 'MultiPolygon',
  coordinates: aoi,
});

const filterRules = rules => {
  return rules.filter(rule => {
    const worldExtent = [-180, -90, 180, 90];
    if (rule.aoi) {
      rule.aoiGeo = parseAoiGeo(rule.aoi);
      const geoExtent = format.readGeometry(rule.aoiGeo).getExtent();
      rule.extent = geoExtent;
      const area = getArea(geoExtent) / getArea(worldExtent);
      rule.worldIntersect = area;
      return true;
    }
    return false;
  });
};

export const initialState = [];

const basemapRules = createReducer(initialState, builder => {
  builder.addCase(fetchBasemapRules.fulfilled, (state, {payload}) => {
    return filterRules(payload.rules);
  });
});

export default basemapRules;
